import { IStore } from "@snackpass/snackpass-types";

/**
 * Centralized builders for google forms
 */

type SetupFormUser =
    | {
          name?: string | null;
          email?: string | null;
          number?: string | null;
      }
    | null
    | undefined;

type SetupFormParams = {
    store?: IStore | null;
    user?: SetupFormUser;
};

const googleFormUrl = (formId: string, params?: URLSearchParams) =>
    `https://docs.google.com/forms/d/e/${formId}/viewform${
        params ? `?${params.toString()}` : ""
    }`;

/**
 * Menu setup request.
 */
const MENU_SETUP_FORM_ID =
    "1FAIpQLSfIIxjXOg59O5zCWtV1FQDVgZTx9LBdSKnRNY24w_HwSA2rww";

export const getMenuSetupUrl = ({ store }: SetupFormParams = {}) =>
    googleFormUrl(
        MENU_SETUP_FORM_ID,
        new URLSearchParams({
            "entry.187146109": store?.name || "",
            "entry.1349461475": store?.address || "",
        }),
    );

/**
 * Catering setup request.
 */
const CATERING_SETUP_FORM_ID =
    "1FAIpQLSf55oco2PA56pkayY2g_xbTSwwXkZHfTbQIchhZ-c-pj-2YVg";

export const getCateringSetupUrl = ({ store }: SetupFormParams = {}) =>
    googleFormUrl(
        CATERING_SETUP_FORM_ID,
        new URLSearchParams({
            "entry.1582282939": store?._id || "",
            "entry.772884399": store?.name || "",
        }),
    );

/**
 * Third party delivery integration ("Integration Request Form" / Deliverect).
 */
const THIRD_PARTY_DELIVERY_FORM_ID =
    "1FAIpQLSd-CbUV63hN7Hk_8dQVz0XxlmIqRW6rU7fLML-PnxNjQ4wAjA";

export const getThirdPartyDeliverySetupUrl = ({
    store,
    user,
}: SetupFormParams = {}) =>
    googleFormUrl(
        THIRD_PARTY_DELIVERY_FORM_ID,
        new URLSearchParams({
            "entry.2042797744": store?.name || "",
            "entry.1333727736": store?.address || "",
            "entry.112839779": store?._id || "",
            "entry.727312995": user?.name || "",
            "entry.370434095": user?.email || "",
            "entry.285496191": user?.number || "",
        }),
    );

/**
 * Custom website builder request.
 */
const WEBSITE_REQUEST_FORM_ID =
    "1FAIpQLSfySK1wmxFM9NsLTJtNXApUBE7DFVOL1_wIO-dss1Ak8vJqiQ";

export const getWebsiteSetupUrl = ({ store }: SetupFormParams = {}) =>
    googleFormUrl(
        WEBSITE_REQUEST_FORM_ID,
        new URLSearchParams({
            "entry.1852912772": store?._id || "",
            "entry.1594734209": store?.name || "",
        }),
    );

/**
 * Commission-free first party delivery setup.
 */
const FIRST_PARTY_DELIVERY_FORM_ID =
    "1FAIpQLSdV75IOHkAYjhcdXImGQWvzE01Ymx3gFaG6-OrqZn3YRlt1rg";

export const getFirstPartyDeliverySetupUrl = ({
    store,
    user,
}: SetupFormParams = {}) =>
    googleFormUrl(
        FIRST_PARTY_DELIVERY_FORM_ID,
        new URLSearchParams({
            "entry.1952110084": user?.name || "",
            "entry.1279863674": user?.email || "",
            "entry.1147421899": user?.number || "",
            "entry.351503267": store?.name || "",
            "entry.1253777027": store?._id || "",
            "entry.1930377384":
                store?.addressComponents?.full || store?.address || "",
        }),
    );
